import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MbCategoryNavigationToolsComponent } from '../mb-category-navigation-tools.component'

@Component({
  selector: 'mb-category-navigation-tools-desktop',
  templateUrl: './mb-category-navigation-tools-desktop.component.html',
  styleUrls: ['./mb-category-navigation-tools-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbCategoryNavigationToolsDesktopComponent extends MbCategoryNavigationToolsComponent {
}
